import {
  YesNo,
  YN,
  EnableStatus,
  PromotionType,
  ListingStatus,
  ScopeType,
  OrderStatus,
  ShipmentStatus,
  Distributor,
  DeductionType,
  DeductionReasonType,
  SysConfigStatus,
  RefundStatus,
  RefundStatusName,
  RbacParentModule,
  RbacParentModuleName,
  RbacResourceParentCode,
  RbacResourceParentCodeName,
  SystemResourceLevel,
  RbacResourceType,
  RbacResourceTypeName,
  RbacRoleScopeType,
  RbacRoleScopeTypeName,
  AccountAffiliation,
  AccountAffiliationName,
  SiteStatus,
  TdlDeviceStatus,
  TdlDeviceSNStatus,
  TdlDeviceType,
  TdlOnlineStatus,
  TdlOptLogType,
  TdlAlarmLevel,
  TdlOrderStatus
} from './enums'

export const commonOptions = {
  // 是否
  yesOrNo: [
    { label: '是', value: YesNo.YES },
    { label: '否', value: YesNo.NO }
  ],

  // 启用禁用
  enableStatus: [
    { label: '启用', value: EnableStatus.ENABLE },
    { label: '禁用', value: EnableStatus.DISABLE }
  ],

  // 站点状态
  siteStatus: [
    { label: '启用', value: SiteStatus.ENABLED },
    { label: '禁用', value: SiteStatus.DISABLED }
  ],

  sysConfigStatus: [
    { label: '新建', value: SysConfigStatus.NEW },
    { label: '启用', value: SysConfigStatus.ENABLE },
    { label: '禁用', value: SysConfigStatus.DISABLE }
  ],

  // 推广类型
  promotionType: [
    { label: '广告推广', value: PromotionType.ADVERTISE },
    { label: '商品推广', value: PromotionType.PRODUCT }
  ],

  // 上下架状态
  listingStatus: [
    { label: '已上架', value: ListingStatus.ON },
    { label: '已下架', value: ListingStatus.OFF }
  ],

  // 生效范围
  scopeType: [
    { label: '所有门店生效', value: ScopeType.ALL_SHOP },
    { label: '按省市区选择', value: ScopeType.LOCATION },
    { label: '按门店编号选择', value: ScopeType.PART_SHOP }
  ],

  // 是否有退款
  hasRefund: [
    { label: '有退款', value: YN.YES },
    { label: '无退款', value: YN.NO }
  ],

  // 订单状态
  orderStatus: [
    { label: '待支付', value: OrderStatus.WAITING_FOR_PAYMENT },
    { label: '已完成', value: OrderStatus.COMPLETED },
    { label: '已取消', value: OrderStatus.CANCELLED }
  ],

  // 发货单状态
  shipmentStatus: [
    { label: '待发货', value: ShipmentStatus.WAIT_SHIPMENT },
    { label: '待入库', value: ShipmentStatus.WAIT_INBOUND },
    { label: '待出库', value: ShipmentStatus.WAIT_OUTBOUND },
    { label: '待出库确认', value: ShipmentStatus.WAIT_CONFIRM_OUTBOUND },
    { label: '已出库', value: ShipmentStatus.OUTBOUND },
    { label: '已退件', value: ShipmentStatus.RETURNED },
    { label: '已关闭', value: ShipmentStatus.CLOSED }
  ],

  // 渠道商
  distributor: [{ label: '兔喜快递柜', value: Distributor.TUXI }],

  deductionClass: [
    { label: '账户余额', value: DeductionType.account },
    { label: '佣金余额', value: DeductionType.commission }
  ],

  accountBalance: [
    { label: '自主退款', value: DeductionReasonType.selfRefund },
    { label: '违规扣款', value: DeductionReasonType.violationDeduct },
    { label: '退出清算', value: DeductionReasonType.exitSettlement }
  ],

  commissionBalance: [
    { label: '线下已打款', value: DeductionReasonType.offlinePaid },
    { label: '违规扣款', value: DeductionReasonType.commissionViolationDeduct },
    { label: '退出清算', value: DeductionReasonType.commissionExitSettlement }
  ],

  refundStatusOptions: [
    { label: RefundStatusName.WAIT_REFUND, value: RefundStatus.WAIT_REFUND },
    { label: RefundStatusName.IN_REFUND, value: RefundStatus.IN_REFUND },
    { label: RefundStatusName.REFUND_SUCCEED, value: RefundStatus.REFUND_SUCCEED },
    { label: RefundStatusName.REFUND_FAIL, value: RefundStatus.REFUND_FAIL }
  ],

  /** RBAC：父级资源根模块（旧编码，兼容） */
  rbacParentModule: [
    { label: RbacParentModuleName.CABINET, value: RbacParentModule.CABINET },
    { label: RbacParentModuleName.CAR, value: RbacParentModule.CAR },
    { label: RbacParentModuleName.SETTINGS, value: RbacParentModule.SETTINGS }
  ],

  /** 资源管理：父级根编码（新增资源用） */
  rbacResourceParentCode: [
    {
      label: RbacResourceParentCodeName[RbacResourceParentCode.MARKETING_CABINET],
      value: RbacResourceParentCode.MARKETING_CABINET
    },
    {
      label: RbacResourceParentCodeName[RbacResourceParentCode.UNMANNED_VEHICLE],
      value: RbacResourceParentCode.UNMANNED_VEHICLE
    },
    {
      label: RbacResourceParentCodeName[RbacResourceParentCode.SYSTEM],
      value: RbacResourceParentCode.SYSTEM
    }
  ],

  rbacResourceType: [{ label: RbacResourceTypeName.PAGE, value: RbacResourceType.PAGE }],

  /** 资源管理：新增时的资源级别 */
  systemResourceLevels: [
    { label: '一级', value: SystemResourceLevel.LEVEL_1 },
    { label: '二级', value: SystemResourceLevel.LEVEL_2 },
    { label: '三级', value: SystemResourceLevel.LEVEL_3 },
  ],

  /** RBAC：角色类型（与角色接口 roleType 一致） */
  rbacRoleScopeType: [
    { label: RbacRoleScopeTypeName.HEADQUARTERS, value: RbacRoleScopeType.HEADQUARTERS },
    { label: RbacRoleScopeTypeName.SUPPLIER, value: RbacRoleScopeType.SUPPLIER }
  ],

  accountAffiliation: [
    { label: AccountAffiliationName.HEADQUARTERS, value: AccountAffiliation.HEADQUARTERS },
    { label: AccountAffiliationName.SUPPLIER, value: AccountAffiliation.SUPPLIER }
  ],

  tdlAlarmLevel: [
    { label: '高', value: TdlAlarmLevel.HIGH },
    { label: '中', value: TdlAlarmLevel.MEDIUM },
    { label: '低', value: TdlAlarmLevel.LOW }
  ],

  tdlDeviceType: [
    { label: '整车', value: TdlDeviceType.VEHICLE },
    { label: '底盘', value: TdlDeviceType.CHASSIS },
    { label: '货仓', value: TdlDeviceType.TRUNK },
    { label: '中控', value: TdlDeviceType.CENTER_CONTROLLER }
    // { label: '梯控', value: TdlDeviceType.ELEVATOR_CONTROLLER } // 暂不支持
  ],

  tdlDeviceStatus: [
    { label: '已停机', value: TdlDeviceStatus.STOPPED },
    { label: '充电中', value: TdlDeviceStatus.CHARGING },
    { label: '装货中', value: TdlDeviceStatus.LOADING_IN_PROGRESS },
    { label: '召回中', value: TdlDeviceStatus.UNDER_RECALL },
    { label: '配送中', value: TdlDeviceStatus.DELIVERY_IN_PROGRESS }
  ],

  tdlOnlineStatus: [
    { label: '在线', value: TdlOnlineStatus.ONLINE },
    { label: '离线', value: TdlOnlineStatus.OFFLINE }
  ],

  tdlDeviceSNStatus: [
    { label: '未使用', value: TdlDeviceSNStatus.UNUSED },
    { label: '已激活', value: TdlDeviceSNStatus.ACTIVATED },
    // { label: '已导出', value: TdlDeviceSNStatus.EXPORTED },
    { label: '已作废', value: TdlDeviceSNStatus.VOIDED }
  ],

  tdlOrderStatus: [
    { label: '已装货', value: TdlOrderStatus.ALREADY_LOADED },
    { label: '配送中', value: TdlOrderStatus.DELIVERING },
    { label: '已送达', value: TdlOrderStatus.DELIVERED },
    { label: '等待中', value: TdlOrderStatus.WAITING },
    { label: '已取消', value: TdlOrderStatus.CANCEL }
  ],

  tdlOptLogType: [
    { label: '添加', value: TdlOptLogType.ADD },
    { label: '更新', value: TdlOptLogType.UPDATE },
    { label: '删除', value: TdlOptLogType.DELETE },
    { label: '导入', value: TdlOptLogType.IMPORT },
    { label: '登录', value: TdlOptLogType.LOGIN },
    { label: '作废', value: TdlOptLogType.VOID },
    { label: '恢复', value: TdlOptLogType.RESTORE },
    { label: '启用', value: TdlOptLogType.ENABLED },
    { label: '禁用', value: TdlOptLogType.DISABLED },
    { label: '召回', value: TdlOptLogType.CALL_BACK },
    { label: '重启', value: TdlOptLogType.REBOOT },
    { label: '停止', value: TdlOptLogType.STOP },
    { label: '发车', value: TdlOptLogType.DEPARTURE },
    { label: '开门', value: TdlOptLogType.OPEN },
    { label: '关门', value: TdlOptLogType.CLOSE }
  ]
}
